import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";
import {
  actionTypes,
  fetchUserEntitlementRequesSuccesstAction,
  fetchUserEntitlementRequestFailureAction,
} from "./actions";
import { fetchUserEntitlementService } from "./services";

const fetchTaskRequestsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_USER_ENTITLEMENT_REQUEST),
    mergeMap(() =>
      fetchUserEntitlementService().pipe(
        map((response) => fetchUserEntitlementRequesSuccesstAction(response)),
        catchError((error: any) =>
          of(fetchUserEntitlementRequestFailureAction(error))
        )
      )
    )
  );

const epics = [fetchTaskRequestsEpic];

export default epics;
